// Wrapper around the `sonner` package, restored: `src/App.js` imports
// `@/components/ui/sonner` and the file was missing from both the source zip
// and the git branch, so the project did not build from a clean checkout. The
// preview builds because Emergent's working directory still has it.
//
// Styled to the site's own tokens rather than sonner's defaults, so a toast
// looks like the rest of the page.
import { Toaster as SonnerToaster } from "sonner";

export function Toaster(props) {
  return (
    <SonnerToaster
      toastOptions={{
        style: {
          background: "var(--paper, #fff)",
          color: "var(--ink, #1a1815)",
          border: "1px solid var(--line, #e8e4da)",
          borderRadius: "10px",
          fontFamily: "var(--sans)",
          fontSize: "13.5px",
        },
      }}
      {...props}
    />
  );
}

export { toast } from "sonner";
export default Toaster;
